/**
 * Return a capitalized version of a given string.
 * @param {string} value string to capitalize
 * @returns {string} capitalized string
 */
export const capitalized = (value) => {
  if (!value) {
    return "";
  }

  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

export const formattedPrice = (price) => {
  if (!price) {
    return "";
  }
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  }).format(price);
};

export function calculateInstallments(totalAmount, downPayment, months = 120) {
  if (totalAmount < downPayment) {
    throw new Error("The down payment cannot be greater than the total amount.");
  }

  const amountWithoutDownPayment = totalAmount - downPayment;
  const installment = amountWithoutDownPayment / months;

  return {
    amount_without_down_payment: amountWithoutDownPayment,
    installment: parseFloat(installment.toFixed(2)), // Round to 2 decimals
  };
}

export function calculateDownPayment(totalPrice, percentage = 20) {
  if (totalPrice <= 0) {
    throw new Error("Total price must be greater than zero.");
  }

  const downPayment = (totalPrice * percentage) / 100;

  return {
    total_price: totalPrice,
    down_payment: parseFloat(downPayment.toFixed(2)), // Round to 2 decimals
    percentage: `${percentage}%`,
  };
}



export function calculateLandTotal(price, surface) {
  if (!price || !surface) {
    return 0;
  }
  const superficie = parseFloat(surface.replace("M2", "").trim());

  const total = superficie * price;

  return total;
}